import {apiBaseUrl} from '../../components/core/globalVariables';

async function fetchMetricData({
  id,
  srid = 4326,
  token,
  numericMetric,
  keyMetric,
}) {

  try {

    const localToken =
      token || localStorage.getItem('token');

    if (!localToken) {
      throw new Error('No token in local storage');
    }

    const metrics = [
      numericMetric,
      keyMetric
    ].filter(
      metric => Boolean(metric)
    );

    // const propertiesStr = ['shortname', 'layer', ...metrics].join(' ');
    const propertiesStr = '*';

    const params = new URLSearchParams({
      srid: String(srid),
      properties: propertiesStr,
      simplify: '2',
    });

    const response = await fetch(
      `${apiBaseUrl}/api/maps/${id}/features?${params.toString()}`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${localToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    if (!response.ok) {

      const errorText = await response.text();

      throw new Error(
        `Metric data request failed: ${response.status} ${errorText}`
      );

    }

    const geoJsonData = await response.json();

    const timestamp =
      new Date().toISOString();

    // console.log(
    //   timestamp +
    //   " " +
    //   "✅ 🔥 INITIAL Fetched GeoJSON SUCCESS:",
    //   geoJsonData
    // );

    return geoJsonData;

  } catch (error) {

    const timestamp =
      new Date().toISOString();

    console.error(
      timestamp +
      " " +
      '❌ 🔥 INITIAL Fetched GeoJSON FAILED:',
      error
    );

    return null;

  }

}

export default fetchMetricData;